(function($) {
	$(document).ready(function() {

		$('.tabs .nav-tabs a').click(function(e){
			e.preventDefault();
			var tabToggle = $(this).attr('href');
			$('.tabs .nav-tabs li').removeClass('active');
			$(this).parent().addClass('active');
			$('.tab-content .tab-pane').removeClass('active');
			$('.tab-content ' + tabToggle).addClass('active');
		});


		enquire.register("screen and (max-width:767px)", {

			// OPTIONAL
		    // If supplied, triggered when a media query matches.
		    match : function() {

		    	var pane_id = '';
		    	$('.tab-content .tab-pane').each(function(){
		    		pane_id = $(this).attr('id');
		    		$(this).insertAfter($('.tabs .nav-tabs a[href="#'+pane_id+'"]'));
		    	});

		    },      
		                               

		});
		enquire.register("screen and (min-width:768px)", {

			// OPTIONAL
		    // If supplied, triggered when a media query matches.
		    match : function() {

		    	$('.tabs .nav-tabs .tab-pane').each(function(){
		    		$(this).appendTo($('.tab-content'));
		    	});

		    },      
		                               

		});

	}); 
})(jQuery);